import { render, staticRenderFns } from "./IconBarometer.vue?vue&type=template&id=0424b631&scoped=true"
import script from "./IconBarometer.vue?vue&type=script&lang=ts"
export * from "./IconBarometer.vue?vue&type=script&lang=ts"
import style0 from "./IconBarometer.vue?vue&type=style&index=0&id=0424b631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0424b631",
  null
  
)

export default component.exports